import clsx from "clsx";
import React from "react";

interface SelectOption {
    name: string;
    value: string;
}

interface SelectProps {
    className?: string;
    options: SelectOption[];
    value?: string;
    defaultValue?: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    name: string;
    ariaLabel?: string;
    isInvalid?: boolean;
    withIcon?: boolean,
}

const SelectInput: React.FC<SelectProps> = (
    {
        className= null,
        options,
        value,
        defaultValue,
        onChange,
        placeholder = null,
        name,
        ariaLabel = null,
        isInvalid = false,
        withIcon = false,
    }) => {
    // If default value is set, use that.
    // Otherwise, if there is a placeholder,
    //      use empty value and show placeholder.
    //      Otherwise, use the first available option or empty value if there are none
    const defaultOrFirstOption = defaultValue || (
        placeholder !== null ? "" : (options.length > 0 ? options[0].value : "")
    )
    const valueProps = value
        ? { value: value }
        : { defaultValue : defaultOrFirstOption }
    ;

    return (
      <div className="select-input relative w-full">
        <select
          id={name}
          name={name}
          onChange={(e) => onChange && onChange(e.target.value)}
          className={clsx(
            "block px-11",
            {
              "invalid": isInvalid,
              "px-3": !withIcon,
              "px-11": withIcon,
            },
            className
          )}
          {...(ariaLabel ? { "aria-label": ariaLabel } : {})}
          {...valueProps}

        >
          {placeholder ? <option value="" disabled>
            {placeholder}
          </option> : null}
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.name}
            </option>
          ))}
        </select>
      </div>
    );
};

export default SelectInput;